<template>
  <!-- 无效 -->
  <!-- 刷新页面跳转 -->
  <div></div>
</template>
    
  <script >
export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.$router.replace(from.path);
    });
  },
  setup() {},
};
</script>